import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressService } from './services/address/address.service';
import { InksofteditorComponent } from '@app/shared/components/inksofteditor/inksofteditor.component';
import { ProductService } from './services/product/product.service';

import { LandingFooterComponent } from '@app/auth/footer/footer.component';
import { LandingHeaderComponent } from '@app/auth/header/header.component';
import { ConfirmationDialogComponent } from '@app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MaterialModule } from '@app/material/material.module';
import { InksoftService } from '@app/shared/services/inksoft/inksoft.service';
import { PublishProductComponent } from './components/publish-product/publish-product.component';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonService } from './services/common/common.service';
import { AddAddressComponent } from './components/add-address/add-address.component';
import { UploadImageDialogComponent } from './components/upload-image-dialog/upload-image-dialog.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { RouterModule } from '@angular/router';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { MessageService } from './services/common/message.service';
import { OrderService } from './services/order/order.service';
import { OrdersComponent } from './components/orders/list/orders.component';
import { OrderConfirmationComponent } from './components/orders/order-confirmation/order-confirmation.component';
import { OrderDetailComponent } from './components/orders/order-detail/order-detail.component';
import { InfiniteScrollDirective, InfiniteScrollModule } from 'ngx-infinite-scroll';
import { OrderDetailResolver } from './routeresolver/order-detail.resolver';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpConfigInterceptor } from './interceptor/httpConfigInterceptor';
import { UploadBannerImageComponent } from './components/upload-banner-image/upload-banner-image.component';
import { ReportService } from './services/reports/report.service';
import { LazyLoaderComponent } from './components/lazy-loader/lazy-loader.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { BaseChartDirective } from 'ng2-charts';
import { BarRating, BarRatingModule } from 'ngx-bar-rating';
import { RatingReviewDialogComponent } from './components/rating-review-dialog/rating-review-dialog.component';
// import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { DashboardService } from './services/dashboard/dashboard.service';
import { ErrorhandlerService } from './services/errorhandler/errorhandler.service';
import { UploadStoreLogoComponent } from './components/upload-store-logo/upload-store-logo.component';
import { NgxMaskDirective,NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { TrackingPopupComponent } from './components/orders/tracking-popup/tracking-popup.component';
import { LazyloadjsService } from './services/lazyloadjs/lazyloadjs.service';
import { BraintreeService } from '@app/shared/services/braintree/braintree.service';
import { PopupIframeComponent } from './components/popup-iframe/popup-iframe.component';
import { StoreComponent } from './iconsvg/store/store.component';
import { InksoftGetListService } from '@app/shared/services/inksoftGetList/inksoft-get-list.service';
import { AddIframeDispatchComponent } from './components/add-iframe-dispatch/add-iframe-dispatch.component';
import { CartComponent } from './iconsvg/cart/cart.component';
import { ProductDetailReviewComponent } from './components/product-detail-review/product-detail-review.component';
import { ProductDetailEditTextComponent } from './components/product-detail-edit-text/product-detail-edit-text.component';
import { AddressIconComponent } from './iconsvg/address-icon/address-icon.component';
import { PreventDoubleClickDirectiveDirective } from './directives/prevent-double-click-directive.directive';
import { SignaturePadComponent } from './components/signature-pad/signature-pad.component';
import { ViewcustomDetailsComponent } from './components/viewcustom-details/viewcustom-details.component';
import { CancelRequestDialogComponent } from './components/cancel-request-dialog/cancel-request-dialog.component';
import { MasterProductListingComponent } from '@app/shared/components/master-product/product-listing/master-product-listing.component';
import { FilterComponent } from '@app/shared/components/filter/filter.component';
import { FilterPipe } from './pipes/filter.pipe';
import { MasterProductDetailComponent } from '@app/shared/components/master-product/product-detail/master-product-detail.component';
import { UploadFileComponent } from './dialogs/upload-file/upload-file.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
import { ReportOrderComponent } from './dialogs/report-order/report-order.component';
import { ReleaseLogComponent } from './components/release-log/release-log.component';
import { SafeHtmlPipe } from './pipes/safehtml.pipe';
import { TransactionDetailDialogComponent } from './dialogs/transaction-detail/transaction-detail.component';

import { NgxPayPalModule } from 'ngx-paypal';
import { LeaveSiteConformationDialogComponent } from './components/leave-site-conformation-dialog/leave-site-conformation-dialog.component';
import { EmbroideryProductInfoComponent } from './components/embroidery-product-info/embroidery-product-info.component';
import { OrderCancelComponent } from './components/order-cancel/order-cancel.component';
import { InventoryHoldingPaymentsComponent } from './components/warehouse/inventory-holding-payments/inventory-holding-payments.component';
import { ODOrdersComponent } from './components/orderdesk/od-orders/od-orders.component';
import { UploadShipcostFileComponent } from './dialogs/upload-shipcost-file/upload-shipcost-file.component';
import { DesignListComponent } from './components/master-product/design-list/design-list.component';
import { MatInputModule } from '@angular/material/input';
import { DragCanvasComponent } from './components/drag-canvas/drag-canvas.component';
import { DesignHuddleEditorComponent } from './components/design-huddle-editor/design-huddle-editor.component';
import { DesignHuddleTemplateSelectorComponent } from './components/design-huddle-template-selector/design-huddle-template-selector.component';
import { DesignHuddleProductCreatorComponent } from './components/design-huddle-product-creator/design-huddle-product-creator.component';
import { DesignHuddleService } from './services/design-huddle/design-huddle.service';
import { DesignHuddleImageService } from './services/design-huddle/design-huddle-image.service';
import { ProjectTitlesDialogComponent } from './components/master-product/project-titles-dialog/project-titles-dialog.component';


@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    ImageCropperComponent,
    InfiniteScrollModule,
    RouterModule,
    BaseChartDirective,
    BarRatingModule,
    FormsModule,
    // MalihuScrollbarModule.forRoot(),
    NgxMaskDirective,
    NgxMaskPipe,
    MatTableModule,
    NgxPayPalModule,
    MatAutocompleteModule,
    InfiniteScrollDirective,
    BarRating,
    MatInputModule,

  ],
  exports: [
    InksofteditorComponent,
    OnlyNumberDirective,
    OrderConfirmationComponent,
    AddIframeDispatchComponent,
    CartComponent,
    PreventDoubleClickDirectiveDirective,
    FilterPipe,
    LandingHeaderComponent,
    LandingFooterComponent,
    LineChartComponent,
    FilterComponent,
    ConfirmationDialogComponent,
    PublishProductComponent,
    OrdersComponent,
    OrderDetailComponent,
    LazyLoaderComponent,
    StoreComponent,
    AddressIconComponent,
    MasterProductListingComponent,
    MasterProductDetailComponent,
    EmbroideryProductInfoComponent,
    InventoryHoldingPaymentsComponent,
    DragCanvasComponent,
    DesignHuddleEditorComponent,
    DesignHuddleTemplateSelectorComponent,
    DesignHuddleProductCreatorComponent,
    TransactionDetailDialogComponent
  ],
  declarations: [
    LandingHeaderComponent,
    LandingFooterComponent,
    InksofteditorComponent,
    OnlyNumberDirective,
    OrderConfirmationComponent,
    PopupIframeComponent,
    AddIframeDispatchComponent,
    CartComponent,
    PreventDoubleClickDirectiveDirective,
    FilterPipe,
    ReleaseLogComponent,
    SafeHtmlPipe,
    ODOrdersComponent,
    StoreComponent,
    MasterProductListingComponent,
    FilterComponent,
    DesignListComponent,
    ProjectTitlesDialogComponent,
    OrderCancelComponent,
    EmbroideryProductInfoComponent,
    ReportOrderComponent,
    UploadShipcostFileComponent,
    UploadFileComponent,
    CancelRequestDialogComponent,
    SignaturePadComponent,
    ProductDetailEditTextComponent,
    TrackingPopupComponent,
    UploadStoreLogoComponent,
    UploadBannerImageComponent,
    UploadImageDialogComponent,
    AddAddressComponent,
    PublishProductComponent,
    ConfirmationDialogComponent,
    MasterProductDetailComponent,
    ProductDetailReviewComponent,
    ViewcustomDetailsComponent,
    ProductDetailComponent,
    OrdersComponent,
    OrderDetailComponent,
    InventoryHoldingPaymentsComponent,
    RatingReviewDialogComponent,
    LineChartComponent,
    LazyLoaderComponent,
    AddressIconComponent,
    DesignListComponent,
    DragCanvasComponent,
    DesignHuddleEditorComponent,
    DesignHuddleTemplateSelectorComponent,
    DesignHuddleProductCreatorComponent,
    TransactionDetailDialogComponent
  ],
  providers: [
    AddressService,
    ProductService,
    InksoftService,
    CommonService,
    MessageService,
    OrderService,
    OrderDetailResolver,
    ReportService,
    DashboardService,
    ErrorhandlerService,
    LazyloadjsService,
    BraintreeService,
    InksoftGetListService,
    DesignHuddleService,
    DesignHuddleImageService,
    provideNgxMask(),
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
}
